import { render, staticRenderFns } from "./OutOfStock.vue?vue&type=template&id=f35c8c18"
import script from "./OutOfStock.vue?vue&type=script&lang=js"
export * from "./OutOfStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports